import * as types from './types';

const INITIAL_STATE = {
  report: null,
  loading: false,
  loadError: null,
  selectedSites: [],
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.ACCUCLAIM_EDIT_LOADING:
      return { ...state, loading: payload };
    case types.ACCUCLAIM_EDIT_LOAD_ERROR:
      return {
        ...state,
        loadError: {
          Title: 'Error',
          Message: payload
            ? payload
            : 'An error has occurred. Please try again',
        },
      };
    case types.ACCUCLAIM_EDIT_GET_REPORT:
      return {
        ...state,
        report: payload,
      };
    case types.ACCUCLAIM_EDIT_SET_SELECTED_SITES:
      return {
        ...state,
        selectedSites: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/accuclaimedit/state/report/reducer.js